import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import SearchBar from '../components/SearchBar';
import Tabs from '../components/Tabs';
import TabContent from '../components/TabContent';
import ApiNavigation from '../components/ApiNavigation';
import ExampleNavigation from '../components/ExampleNavigation';

var LNB =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(LNB, _React$Component);

  function LNB() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = LNB.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        useExample = _this$props.useExample,
        tabIndex = _this$props.tabIndex,
        selectedNavItemId = _this$props.selectedNavItemId,
        width = _this$props.width;
    return React.createElement("aside", {
      className: "lnb",
      style: {
        width: width
      }
    }, React.createElement(SearchBar, null), useExample ? React.createElement(Tabs, {
      tabIndex: tabIndex
    }, React.createElement(TabContent, {
      name: "API"
    }, React.createElement(ApiNavigation, {
      selectedId: selectedNavItemId
    })), React.createElement(TabContent, {
      name: "Examples"
    }, React.createElement(ExampleNavigation, {
      selectedId: selectedNavItemId
    }))) : React.createElement(ApiNavigation, {
      selectedId: selectedNavItemId
    }));
  };

  return LNB;
}(React.Component);

export default LNB;